import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const partnerOrganizationParentInfoSchema = z.object({
    id: z.string(),
    name: z.string(),
    owner: z.object({
        email: z.email().nullish(),
    }),
});
export class PartnerOrganizationParentInfoResponseDto extends createZodDto(partnerOrganizationParentInfoSchema) {
}
